import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getButtonClasses } from '#pplx/frontend/aether/components/Button/classes.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
const tryJSONParse = (toParse) => {
    try {
        return JSON.parse(toParse);
    }
    catch {
        return null;
    }
};
// Aether Button text variants do not expose inverse/on-color text for bg-negative-strong/bg-super-strong.
// ButtonPrimitive preserves the text-only retry action without scoped selectors or
// __dangerousHtmlProps class overrides.
const RETRY_BUTTON_CLASS_NAME = getButtonClasses({
    variant: 'text',
    inline: true,
});
export const ErrorComponent = React.memo(function ErrorComponent({ title, description, className = '', role, retryFn, retryLabel, ...divProps }) {
    const { $t } = useIntl();
    const defaultDescription = $t({
        defaultMessage: 'Please try again later.',
        id: 'dbc081c6e8',
        description: 'Default fallback description shown in the error component',
    });
    // If it parses, we're probably inadvertently exposing some low-level data
    const parsed = useMemo(() => tryJSONParse(description ?? ''), [description]);
    if (parsed) {
        console.warn('Tried to pass a JSON error description');
        console.warn(parsed);
    }
    return (_jsxs("div", { className: `gap-4 bg-negative-strong py-2 px-4 flex items-center rounded-lg text-left font-sans text-white ${className}`, role: "alert", ...divProps, children: [_jsx(Icon, { icon: $icon('alert-circle') }), _jsxs("div", { className: "flex grow flex-col", children: [_jsx("p", { className: "font-medium", children: title ||
                            $t({
                                defaultMessage: 'Sorry, something went wrong',
                                id: 'f1e97e36d1',
                                description: 'Text in the Error Component error page section',
                            }) }), _jsx("p", { children: parsed ? defaultDescription : description })] }), retryFn && (_jsx(ButtonPrimitive, { className: RETRY_BUTTON_CLASS_NAME, onClick: retryFn, children: _jsx("span", { className: "text-box-trim-both text-inverse", children: retryLabel ??
                        $t({
                            defaultMessage: 'Try again',
                            id: '7b47b2b924',
                            description: 'Retry button label in the error component',
                        }) }) }))] }));
});
//# sourceMappingURL=ErrorComponent.js.map